import Style from "./style"
import useTosspayments from "./model/useTosspayments"

import DefaultButton from "shared/ui/DefaultButton"
import convertMoney from "shared/lib/convertMoney"

const PaymentWidget = ({ amount, orderName, callbackUrl }) => {
    const [clickPaymentEvent] = useTosspayments(amount, orderName, callbackUrl)

    return (
        <Style.Wrapper>
            <div id="payment-method"></div>
            <div id="agreement"></div>

            <Style.Area>
                <h2>{orderName}</h2>
                <p>{convertMoney(amount)} KRW</p>
            </Style.Area>

            <Style.BtnDiv>
                <DefaultButton clickEvent={clickPaymentEvent}>결제하기</DefaultButton>
            </Style.BtnDiv>
        </Style.Wrapper>
    )
}

export default PaymentWidget